function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.19059 0H0.809412C0.357647 0 0 0.357647 0 0.809412V7.19059C0 7.64235 0.357647 8 0.809412 8H7.19059C7.64235 8 8 7.64235 8 7.19059V0.809412C8 0.357647 7.64235 0 7.19059 0Z",
  fill: "#081F2D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1906 0H10.8094C10.3576 0 10 0.357647 10 0.809412V7.19059C10 7.64235 10.3576 8 10.8094 8H17.1906C17.6424 8 18 7.64235 18 7.19059V0.809412C18 0.357647 17.6424 0 17.1906 0Z",
  fill: "#081F2D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.19059 10H0.809412C0.357647 10 0 10.3576 0 10.8094V17.1906C0 17.6424 0.357647 18 0.809412 18H7.19059C7.64235 18 8 17.6424 8 17.1906V10.8094C8 10.3576 7.64235 10 7.19059 10Z",
  fill: "#081F2D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1906 10H10.8094C10.3576 10 10 10.3576 10 10.8094V17.1906C10 17.6424 10.3576 18 10.8094 18H17.1906C17.6424 18 18 17.6424 18 17.1906V10.8094C18 10.3576 17.6424 10 17.1906 10Z",
  fill: "#081F2D"
});

function SvgGridIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid-icon.ab519a54.svg";
export { ForwardRef as ReactComponent };